// 面包屑分类追踪器
(function() {
  // 在分类页面，记录客户点击的分类
  if (window.location.pathname.includes('/collections/')) {
    const collectionMatch = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
    if (collectionMatch) {
      const collectionHandle = collectionMatch[1];
      
      // 页面加载完成后，为产品链接添加点击事件
      document.addEventListener('DOMContentLoaded', function() {
        const productLinks = document.querySelectorAll('a[href*="/products/"]');
        productLinks.forEach(link => {
          link.addEventListener('click', function() {
            sessionStorage.setItem('lastVisitedCollection', collectionHandle);
          });
        });
      });
    }
  }
  
  // 在产品页面，显示客户实际访问的分类
  if (window.location.pathname.includes('/products/')) {
    document.addEventListener('DOMContentLoaded', function() {
      const lastCollection = sessionStorage.getItem('lastVisitedCollection');
      const breadcrumbElement = document.getElementById('breadcrumb-collection');
      
      if (lastCollection && breadcrumbElement) {
        // 将分类handle转换为标题格式
        const collectionTitle = lastCollection
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        // 更新面包屑显示
        breadcrumbElement.innerHTML = `<a href="/collections/${lastCollection}" title="${collectionTitle}">${collectionTitle}</a>`;
      }
    });
  }
})();
